// src/pages/Home.jsx
import { Helmet } from "react-helmet-async";

/* ================= WHATSAPP (PADRÃO DO SITE) ================= */
function getWhatsAppLink(pathname = "/") {
  const number = "5527995785444";

  let intro = "Olá! Quero uma proposta para meu evento.";
  let context = "";

  if (pathname === "/cenografia") {
    context = "Tenho interesse em um projeto de CENOGRAFIA.";
  } else if (pathname === "/iluminacao") {
    context = "Tenho interesse em um projeto de ILUMINAÇÃO CÊNICA.";
  } else if (pathname === "/portfolio") {
    context = "Vi o portfólio e quero algo nesse nível.";
  } else if (pathname === "/contato") {
    context = "Quero conversar sobre um projeto.";
  }

  const text = encodeURIComponent(
    `${intro}\n\n${context}\n\n` +
      "• Data do evento:\n" +
      "• Cidade/Local:\n" +
      "• Tipo de evento:\n" +
      "• Referências (se tiver):\n"
  );

  return `https://wa.me/${number}?text=${text}`;
}

function Home() {
  const title = "Cenografia e Iluminação Cênica de Impacto | Cenovix";
  const description =
    "Cenografia e iluminação cênica de impacto para eventos, feiras e ativações. Projetos sob medida com foco em estética, leitura de marca e resultado em foto e vídeo.";
  const url = "https://www.cenovix.com.br/";
  const ogImage = "https://www.cenovix.com.br/images/og-cenovix.jpg";

  const waLink = getWhatsAppLink("/");

  return (
    <div>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={url} />
        <meta name="robots" content="index,follow,max-image-preview:large" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Cenovix" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={url} />
        <meta property="og:image" content={ogImage} />
        <meta
          property="og:image:alt"
          content="Cenovix — Cenografia e Iluminação Cênica"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={ogImage} />

        <meta name="theme-color" content="#0b0b0c" />
      </Helmet>

      {/* ================= HERO ================= */}
      <section
        className="hero"
        aria-label="Cenovix - Cenografia e Iluminação Cênica"
      >
        {/* Desktop (imagem real para carregar melhor) */}
        <img
          className="hero-media hero-media--desktop"
          src="/images/home/hero.jpg"
          alt="Cenografia e iluminação cênica de impacto"
          loading="eager"
          decoding="async"
          fetchpriority="high"
        />

        {/* Mobile */}
        <img
          className="hero-media hero-media--mobile"
          src="/images/home/hero-mobile.png"
          alt="Cenografia e iluminação cênica para eventos"
          loading="eager"
          decoding="async"
        />

        <div className="hero-overlay" />

        <div className="hero-content">
          <h1>
            Cenografia e Iluminação Cênica <span>de Impacto</span>
          </h1>

          <p className="hero-subtitle">
            Projetos para <strong>eventos, feiras e ativações</strong> com foco
            em <strong>impacto visual</strong> e resultado em{" "}
            <strong>foto e vídeo</strong>.
            <br />
            <span style={{ opacity: 0.92 }}>
              Localizados em <strong>Vila Velha</strong>, atendemos todo{" "}
              <strong>Brasil</strong>.
            </span>
          </p>

          <div className="hero-stats" aria-label="Prova social Cenovix">
            <div className="stat">
              <span className="stat-number">500+</span>
              <span className="stat-label">eventos entregues</span>
            </div>

            <div className="stat">
              <span className="stat-number">5+</span>
              <span className="stat-label">anos no mercado</span>
            </div>
          </div>
        </div>
      </section>

      {/* ================= PROVAS VISUAIS ================= */}
      <section className="visual-editorial" aria-label="Portfólio em destaque">
        <div className="visual-editorial__grid">
          <figure className="visual-tile visual-tile--big">
            <img
              src="/images/home/prova-1.png"
              alt="Cenografia Cenovix em evento: organização e comunicação do espaço"
              loading="lazy"
              decoding="async"
            />
            <figcaption className="visual-caption">
              Cenografia que organiza e comunica o espaço
            </figcaption>
          </figure>

          <div className="visual-editorial__stack">
            <figure className="visual-tile">
              <img
                src="/images/home/prova-2.png"
                alt="Iluminação cênica Cenovix: atmosfera e destaque"
                loading="lazy"
                decoding="async"
              />
              <figcaption className="visual-caption">
                Iluminação que cria atmosfera e destaque
              </figcaption>
            </figure>

            <figure className="visual-tile">
              <img
                src="/images/home/prova-3.png"
                alt="Projeto Cenovix: pensado para público, foto e vídeo"
                loading="lazy"
                decoding="async"
              />
              <figcaption className="visual-caption">
                Projeto pensado para público, foto e vídeo
              </figcaption>
            </figure>
          </div>
        </div>
      </section>

      {/* ================= SOLUÇÕES ================= */}
      <section>
        <h2>Soluções para eventos que pedem mais do que o básico</h2>

        <div className="solution-cards">
          <div className="solution-card">
            <h3>Corporativo</h3>
            <p>
              Cenografia e iluminação cênica para convenções, feiras, stands,
              encontros de marca e ativações. Projetos pensados para funcionar
              ao vivo, em foto e em vídeo.
            </p>
          </div>

          <div className="solution-card">
            <h3>Social</h3>
            <p>
              Iluminação e cenografia para eventos sociais e celebrações, com
              projetos personalizados que valorizam o espaço, a atmosfera e a
              experiência dos convidados.
            </p>
          </div>
        </div>
      </section>

      {/* ================= O QUE ENTREGAMOS ================= */}
      <section>
        <h2>O que entregamos</h2>
        <ul>
          <li>Conceito criativo alinhado à identidade do evento ou da marca</li>
          <li>Cenografia e iluminação pensadas como um conjunto visual</li>
          <li>Leitura clara do espaço e proporção estética</li>
          <li>Acompanhamento técnico do início à entrega final</li>
          <li>Montagem e finalização no local do evento</li>
        </ul>
      </section>

      {/* ================= COMO FUNCIONA ================= */}
      <section>
        <h2>Como funciona</h2>

        <div className="process-flow">
          <div className="process-step">
            <div className="process-step__content">
              <h3>Briefing</h3>
              <p>Entendimento do evento, objetivos e referências visuais.</p>
            </div>
          </div>

          <div className="process-arrow" aria-hidden="true">
            →
          </div>

          <div className="process-step">
            <div className="process-step__content">
              <h3>Conceito</h3>
              <p>Definição da proposta criativa e viabilidade técnica.</p>
            </div>
          </div>

          <div className="process-arrow" aria-hidden="true">
            →
          </div>

          <div className="process-step">
            <div className="process-step__content">
              <h3>Produção</h3>
              <p>Produção, planejamento e organização do projeto.</p>
            </div>
          </div>

          <div className="process-arrow" aria-hidden="true">
            →
          </div>

          <div className="process-step">
            <div className="process-step__content">
              <h3>Montagem</h3>
              <p>Montagem, ajustes finais e entrega do projeto.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ================= ONDE ATUAMOS ================= */}
      <section aria-label="Onde atuamos">
        <h2>Onde atuamos</h2>

        <div className="solution-cards">
          <div className="solution-card">
            <h3>Vila Velha • Vitória • Grande Vitória</h3>
            <p>
              Atuamos com cenografia e iluminação cênica em Vila Velha, Vitória e
              Grande Vitória, atendendo eventos corporativos e sociais em todo o
              Espírito Santo.
            </p>
          </div>
        </div>
      </section>

      {/* ================= CTA FINAL ================= */}
      <section>
        <h2>Quer um projeto com identidade e impacto visual?</h2>

        <p>
          Para agilizar o atendimento, envie pelo WhatsApp a{" "}
          <strong>data</strong>, o <strong>local</strong>, o{" "}
          <strong>tipo de evento</strong> e, se possível,{" "}
          <strong>referências visuais</strong>.
        </p>

        <a
          className="cta"
          href={waLink}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Falar no WhatsApp"
        >
          Falar no WhatsApp
        </a>
      </section>
    </div>
  );
}

export default Home;
